import { cva, type VariantProps } from "class-variance-authority"
import type { FC } from "react"
import { cn } from "@/utils/cn"

export const proseVariants = cva(
  cn(
    "prose prose-neutral dark:prose-invert max-w-none break-words prose-a:underline-offset-2",
    // Disable quotation marks
    "before:prose-p:content-none after:prose-p:content-none",
    // Code
    "prose-pre:bg-muted/50 prose-pre:font-medium prose-pre:text-foreground",
    // Headings
    "prose-headings:text-balance prose-headings:font-display prose-headings:leading-[1.25] prose-headings:tracking-tight",
    "prose-h1:font-extrabold prose-h1:text-4xl",
    "prose-h2:font-extrabold prose-h2:text-3xl",
    "prose-h3:font-bold prose-h3:text-2xl",
    "prose-h4:font-bold prose-h4:text-xl",
    "prose-h5:font-bold prose-h5:text-lg",
    "prose-h6:font-bold prose-h6:text-lg",
  ),
  {
    variants: {
      size: {
        xs: "prose-sm text-xs",
        sm: "prose-sm text-sm",
        base: "prose-base text-base",
        lg: "prose-lg text-lg",
      },
      variant: {
        default: "prose-a:text-inherit text-foreground",
      },
      links: {
        default:
          "prose-a:font-semibold prose-a:underline prose-a:decoration-foreground/30 prose-a:hover:decoration-foreground/60",
        subtle:
          "prose-a:underline prose-a:decoration-foreground/30 hover:prose-a:decoration-foreground/60",
      },
    },
    defaultVariants: {
      size: "base",
      variant: "default",
      links: "default",
    },
  },
)

interface ProseProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof proseVariants> {}
export const Prose: FC<ProseProps> = ({ size, variant, links, className, ...rest }) => (
  <div className={proseVariants({ size, variant, links, className })} {...rest} />
)
